import { useCallback, useMemo, useState } from 'react';
import type { BrandInsightsPageContext } from '@trinity/chat';
import { BrandInsightsModalContext } from '@trinity/chat-components/components/BrandInsights/context.js';
import { ChartFilterProvider } from '@trinity/chat-components/components/Chat/Chat.Chart.Filter.Context.js';
import { ChatPageContextDataContext, DispatchPageContextDataContext } from '@trinity/chat-components/components/Chat/context.js';
import { useAppReadyState } from '@/containers/AppReadyState';

type Props = {
  children: React.ReactNode;
};

const ChatManagementContainer = (props: Props) => {

  const [contextData, setContextData] = useState<BrandInsightsPageContext.Item>(null);

  const [open, setOpen] = useState(false);
  // The side panel host opens and closes the modal explicitly when the viewport crosses its
  // breakpoint, so an argument sets the state and no argument toggles it.
  const handleToggle = useCallback(
    (next?: boolean) => setOpen(prev => (typeof next === 'boolean' ? next : !prev)),
    []
  );

  const modalCtx = useMemo<[boolean, (open?: boolean) => void]>(() => [open, handleToggle], [open, handleToggle]);

  return (
    <BrandInsightsModalContext.Provider value={modalCtx}>
      <DispatchPageContextDataContext.Provider value={setContextData}>
        <ChatPageContextDataContext.Provider value={contextData}>
          <ChartFilterProvider>
            {props.children}
          </ChartFilterProvider>
        </ChatPageContextDataContext.Provider>
      </DispatchPageContextDataContext.Provider>
    </BrandInsightsModalContext.Provider>
  );
};

export const BrandInsightsContainer = (props: Props) => {
  const app = useAppReadyState();

  const initialized = app.initialized && app.authenticated;

  if (!initialized) {
    return (
      <>
        {props.children}
      </>
    );
  }

  return (
    <ChatManagementContainer>
      {props.children}
    </ChatManagementContainer>
  );
};